import http from '../Http';
import { DATA_ENDPOINTS, SUBMIT_ENDPOINTS } from '../constants/Endpoints';

class SubjectUtil {
  static getSubjects() {
    return http.get(DATA_ENDPOINTS.SUBJECTS).then(response => ({
      data: {
        count: response.data.length,
        results: response.data,
      },
    }));
  }

  static createSubject(subject) {
    return http.post(SUBMIT_ENDPOINTS.SUBJECTS.CREATE, subject);
  }

  static updateSubject(subjectId, data) {
    return http.put(SUBMIT_ENDPOINTS.SUBJECTS.UPDATE.replace('{id}', subjectId), data);
  }

  static deleteSubject(subjectId) {
    return http.delete(SUBMIT_ENDPOINTS.SUBJECTS.DELETE.replace('{id}', subjectId));
  }
}

export default SubjectUtil;
